import React from 'react';
import { Link } from 'react-router-dom';

const NewsItem = ({ id, title, image, description }) => {
  return (
    <div className="news-item">
      <Link to={`/berita/${id}`}>
        <img src={`${process.env.REACT_APP_BACKEND_URL}/public/upload/${image.filename}`} alt={title} />
        <h3>{title}</h3>
        <p>{description}</p>
      </Link>
    </div>
  );
};

export default NewsItem;
